<template>
  <div
    ref="wrapper"
    class="animate-expand"
  >
    <div
      ref="content"
      class="animate-expand__content"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import { markRaw } from 'vue'

export default {
  name: 'AnimateExpand',

  data () {
    return {
      resizeObserver: null,
    }
  },

  mounted () {
    // markRaw keeps the observer out of Vue reactivity — a reactive proxy breaks its slot methods ("Illegal invocation").
    this.resizeObserver = markRaw(new ResizeObserver(() => {
      this.$refs.wrapper.style.height = `${this.$refs.content.offsetHeight}px`
    }))

    this.resizeObserver.observe(this.$refs.content)
  },

  beforeUnmount () {
    this.resizeObserver?.disconnect()
  },
}
</script>

<style scoped>
.animate-expand {
  height: 0;
  overflow: hidden;
  transition: height 300ms ease-in-out;
}
</style>
